import {
  isLIFF,
  isTalaria,
  getInterfaceType,
  getAppName,
  getAppVersion,
  getOS,
  getOsVersion,
  isEAB,
  isIAB,
  isIOS,
  isLIFFBrowser,
  isLINE,
  isLINEIAB,
  isSafari,
  isUPay,
  isWebBrowser,
} from '@pay-mono-web/webview-manager';

export default class WebviewManagerUtils {
  get interfaceType() {
    return getInterfaceType();
  }

  get appName() {
    return getAppName();
  }

  get isIOS() {
    return isIOS();
  }

  get isLIFFBrowser() {
    return isLIFFBrowser();
  }

  get isTalaria() {
    return isTalaria();
  }

  get isLIFF() {
    return isLIFF();
  }

  get isLINE() {
    return isLINE();
  }

  get isUPay() {
    return isUPay();
  }

  get isEAB() {
    return isEAB();
  }

  get isLINEIAB() {
    return isLINEIAB();
  }

  get isIAB() {
    return isIAB();
  }

  get isWebBrowser() {
    return isWebBrowser();
  }

  get isEABorWebBrowser() {
    return isEAB() || isWebBrowser();
  }

  get isSafari() {
    return isSafari();
  }

  get os() {
    return getOS();
  }

  get osVersion() {
    return getOsVersion();
  }

  get appVersion() {
    return getAppVersion();
  }

}
